"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRequest = void 0;
const umi_request_1 = require("umi-request");
const constants_1 = require("../constants");
function createRequest(options = {}) {
    return umi_request_1.extend(Object.assign({ timeout: constants_1.DEFAULT_REQUEST_TIMEOUT, credentials: 'include' }, options));
}
exports.createRequest = createRequest;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvcmVxdWVzdC9yZXF1ZXN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDZDQUF3RTtBQUV4RSw0Q0FBdUQ7QUFFdkQsU0FBZ0IsYUFBYSxDQUFDLFVBQThCLEVBQUU7SUFDNUQsT0FBTyxvQkFBTSxpQkFDWCxPQUFPLEVBQUUsbUNBQXVCLEVBQ2hDLFdBQVcsRUFBRSxTQUFTLElBQ25CLE9BQU8sRUFDVixDQUFDO0FBQ0wsQ0FBQztBQU5ELHNDQU1DIn0=